/*
	navigation
*/

var functions = window.nffleet_functions;
var variables = window.nffleet_variables;

var subMenuClass = "header__bottom__menu__sub-menu";

var previousMenuItem;
var currentMenuItem;
var currentSubMenu;
var currentActiveMenuItems = document.getElementsByClassName("menu-item " + variables.activeClass);

if (currentActiveMenuItems.length === 1) {
    currentMenuItem = currentActiveMenuItems[0];
}

var menuLinks = document.getElementsByClassName("menu-link");

var menuLinkAction = function (e) {
    var menuLink = e.target;
    var menuItem = menuLink.parentElement;

    //we shouldn't do anything if menu item is selectable - this means the menu item has no children
    if (menuItem.classList.contains(variables.selectableClass)) {
        return;
    }

    //prevent default behaviour - prevents page refresh
    e.preventDefault();

    if (!currentMenuItem) {
        currentMenuItem = menuItem
    }
    else
    {
        var tmpPrev = currentMenuItem;

        if (!previousMenuItem) {
            previousMenuItem = currentMenuItem;
            tmpPrev = previousMenuItem;
        }

        currentMenuItem = menuItem;

        functions.handleClass(tmpPrev, variables.activeClass, false);
    }

    var addActiveClass = !currentMenuItem.classList.contains(variables.activeClass);
    var subMenus = currentMenuItem.getElementsByClassName(subMenuClass);

    if (subMenus.length === 1) {

        var subMenu = subMenus[0];

        if (currentSubMenu === subMenu) {
            if (subMenu.classList.contains(variables.showClass)) {
                //clicked on the same menu item -> sub menu IS visible -> resetNavigation()
                resetNavigation();
            } else {
                //clicked on the same menu item -> sub menu is NOT visible -> show sub menu
                functions.handleClass(subMenu, variables.showClass, true);
            }
        } else if (currentSubMenu !== subMenu) {
            //clicked on new menu item -> hide prev sub menu and show new
            functions.handleClass(currentSubMenu, variables.showClass, false);
            functions.handleClass(subMenu, variables.showClass, true);
        }

        currentSubMenu = subMenu;
    }

    functions.handleClass(currentMenuItem, variables.activeClass, addActiveClass);
};

for (var i = 0; i < menuLinks.length; i++) {
    menuLinks[i].addEventListener(variables.clickListener, menuLinkAction, false);
}

//if user clicks anywhere outside the menu
document.addEventListener(variables.clickListener, function (e) {
    var myElementToCheckIfClicksAreInsideOf = document.getElementsByClassName('header__bottom')[0];
    if (!myElementToCheckIfClicksAreInsideOf.contains(e.target)) {
        resetNavigation();
    }
}, false);

function resetNavigation() {
    //hide sub menu
    functions.handleClass(currentSubMenu, variables.showClass, false);

    if (previousMenuItem && previousMenuItem !== currentMenuItem) {
        //remove active class from current active item and set previousMenuItem as current active 
        functions.handleClass(currentMenuItem, variables.activeClass, false);
        functions.handleClass(previousMenuItem, variables.activeClass, true);

        //reset global variables
        currentMenuItem = previousMenuItem;
        previousMenuItem = undefined;
    }
}

/*
    fixed navigation
*/

var navbar = document.getElementsByClassName("header__bottom")[0];
var offsetTop = navbar.offsetTop;

// Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
window.addEventListener(variables.scrollListener,
    function scrollFunction() {
        functions.handleClass(navbar, "fixed-nav", window.pageYOffset >= offsetTop);
    });